import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/DuplicateVinQuery'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class DuplicateVinQueryStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "DuplicateVinQueryStore",
			variables: false,
		})
	}
}

export async function load_DuplicateVinQuery(params) {
  await initClient()

	const store = new DuplicateVinQueryStore()

	await store.fetch(params)

	return {
		DuplicateVinQuery: store,
	}
}
